import { render, staticRenderFns } from "./AiRiskAssessment.vue?vue&type=template&id=87053736&scoped=true"
import script from "./AiRiskAssessment.vue?vue&type=script&lang=js"
export * from "./AiRiskAssessment.vue?vue&type=script&lang=js"
import style0 from "./AiRiskAssessment.vue?vue&type=style&index=0&id=87053736&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87053736",
  null
  
)

export default component.exports